import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

// MUI
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

// MUI Icons
import AddCircleIcon from "@mui/icons-material/AddCircle";


type MapRouteBoxNoPointsType = {
  hideVideo?: boolean;
}

const MapRouteBoxNoPoints: FC<MapRouteBoxNoPointsType> = (props) => {

  const { hideVideo = false } = props;

  const { t } = useTranslation();

  return (
    <Box width="100%" m={0} p={0}>
      <Typography variant="h6" component="h2">
        {" "}
        {t("titles.no_points")}
      </Typography>
      <Box mt={2} p={0} width="100%" display="flex" flex="row">
        <Typography variant="body1">
          {t("routes.info_1")}
          <AddCircleIcon
            sx={{
              verticalAlign: "bottom",
              paddingLeft: 0,
              paddingRight: 0,
              marginLeft: 0,
              marginRight: 0,
            }}
            color="primary"
          />
          {t("routes.info_2")}
        </Typography>
      </Box>
      { !hideVideo ?
        <Stack
          direction="row"
          mt={2}
          alignItems="center"
          justifyContent="center"
        >
          <img src="videos/help_route.gif" width={368} height={368} alt="help route"/>
        </Stack>
      : null }
    </Box>);
}

export default MapRouteBoxNoPoints;
